import { clone } from "ramda";

const unitFormatSpec = (unitList, count, unitKey) => {
    let unitList1 = clone(unitList);
  const baseUnitRate = unitList1.find((u) => u.unitKey === unitKey); // 找出单位
  if (!baseUnitRate) return [];
  // 把单位转为基本单位
  let countRate = count * baseUnitRate.rate;
  for (var i = unitList1.length - 1; i >= 0; i--) {
    const { rate } = unitList1[i];
    unitList1[i].formatVal = Math.floor(countRate / rate); // 给list中添加了format中添加了字段
    countRate = countRate % rate; // 存储余数
    // 如果余数为0，则直接跳出
    if (countRate === 0) break;
  }
  return unitList1;
};
export default unitFormatSpec;
